import React from "react";
import { X } from "lucide-react";
import { PrimaryButton } from "./Button";
import successIcon from "../assets/success-icon.png";
import locationIcon from "../assets/location-icon.png";

interface BookingModalProps {
  isOpen: boolean;
  onClose: () => void;
  bookingDetails: {
    date: string; // e.g. "AUG 12"
    time: string; // e.g. "10:00 AM - 11:00 AM"
    trainerName: string; // e.g. "Lazar Amigano"
    location: string; // e.g. "HOME"
    address: string; // e.g. "Building no 356, 3rd floor, 29th street"
  };
  onMessageTrainer: () => void;
}

const BookingModal: React.FC<BookingModalProps> = ({ isOpen, onClose, bookingDetails, onMessageTrainer }) => {
  if (!isOpen) return null;

  const [month, day] = bookingDetails.date.split(" "); // "AUG 12"

  return (
    <div 
      className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50"
      onClick={onClose}
    >
      <div 
        className="bg-white w-[360px] p-6 shadow-xl relative"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-400 hover:text-gray-600"
        >
          <X size={20} />
        </button>

         {/* Success Checkmark */}
         <div className="flex justify-center mb-4 mt-10">
           <img 
             src={successIcon} 
             alt="Success" 
             className="w-12 h-12"
           />
         </div>

        {/* Title */}
        <h2 className="text-center text-green-600 font-semibold text-lg mb-6">
          Booked Successfully
        </h2>

         {/* Date & Trainer */}
         <div className="border rounded-md flex">
           <div className="bg-gray-100 w-20 flex flex-col items-center justify-center py-2">
             <span className="text-sm font-semibold">{month}</span>
             <span className="text-2xl font-bold">{day}</span>
           </div>
           <div className="flex-1 px-3 py-2">
             <p className="text-sm text-gray-600">{bookingDetails.time}</p>
             <p className="font-semibold">{bookingDetails.trainerName}</p>
           </div>
         </div>

         {/* Location */}
         <div className="mt-5">
           <p className="text-gray-500 text-sm flex items-center gap-1">
             <img 
               src={locationIcon} 
               alt="Location" 
               className="w-4 h-4"
             />
             LOCATION
           </p>
           <p className="font-semibold mt-1">{bookingDetails.location}</p>
           <p className="text-sm text-gray-600">
             {bookingDetails.address}
           </p>
         </div>

         {/* Button */}
         <div className="mt-6">
           <PrimaryButton
             label="MESSAGE TRAINER"
             onClick={onMessageTrainer}
             className="!w-full"
           />
         </div>
      </div>
    </div>
  );
};

export default BookingModal;
